import { removeTooltips, validateField, needsValidate } from '../utils/forms'

export default function () {
  const page = document.querySelector(
    '.PageMain--client-education-library, .PageMain--article-client-education-library'
  )
  const shareArticleModal = document.querySelector(
    '.ModalShareArticleClientEducation'
  )

  if (!page || !shareArticleModal) {
    return
  }

  const shareArticleBtn = Array.from(page.querySelectorAll('.ShareIcon--email'))

  shareArticleBtn.forEach(function (button) {
    button.addEventListener('click', function () {
      prepareModal(this, shareArticleModal)
    })
  })

  const modalOverlay = shareArticleModal.querySelector(
    '.ModalShareArticleClientEducation__overlay'
  )
  const closeModalBtns = Array.from(
    shareArticleModal.querySelectorAll(
      '.ModalShareArticleClientEducation__close-modal'
    )
  )

  if (closeModalBtns) {
    closeModalBtns.forEach(function (closeModalBtn) {
      closeModalBtn.addEventListener('click', function (event) {
        event.preventDefault()
        closeModal(shareArticleModal)
      })
    })
  }

  if (modalOverlay) {
    // close modal clicking anywhere outside the modal
    modalOverlay.addEventListener('click', function () {
      window.onclick = function (e) {
        if (e.target == modalOverlay) {
          closeModal(shareArticleModal)
        }
      }
    })
  }

  const form = shareArticleModal.querySelector('form')

  if (form) {
    form.addEventListener('submit', async function (event) {
      event.preventDefault()

      const submitBtn = shareArticleModal.querySelector('button[type="submit"]')

      if (submitBtn) {
        submitBtn.disabled = true
      }

      // prevent bot
      if (!form.field || form.field.value != '') {
        showError(form, 'Sorry, we had a problem sharing this article.')
        return false
      }

      // validate
      if (!formValidate(form)) {
        if (submitBtn) {
          submitBtn.disabled = false
        }

        return false
      }

      if (form.articleId && form.articleId.value == '') {
        showError(form, 'Sorry, we had a problem sharing this article.')
        return false
      }

      const data = {
        articleId: form.articleId.value,
        name: form.name.value,
        clinicName: form.clinicName.value,
        recipientEmail: form.recipientEmail.value,
      }

      // check if use Recaptcha
      if (
        request &&
        request?.clientEducationLibrary?.useRecaptcha &&
        wpcf7_recaptcha &&
        wpcf7_recaptcha?.sitekey
      ) {
        if (!grecaptcha) {
          showError(form, 'Sorry, we had a problem sharing this article.')
          return false
        }

        grecaptcha.ready(function () {
          grecaptcha
            .execute(wpcf7_recaptcha.sitekey, { action: 'submit' })
            .then(function (token) {
              data.token = token
              submitForm(shareArticleModal, form, data)
            })
        })
      } else {
        submitForm(shareArticleModal, form, data)
      }
    })
  }
}

async function submitForm(shareArticleModal, form, data) {
  const result = await sendEmail(data)

  if (result) {
    const formContent = shareArticleModal.querySelector('._form-content')
    const formThankYou = shareArticleModal.querySelector('._form-thank-you')

    if (formContent) {
      formContent.style.display = 'none'
    }

    if (formThankYou) {
      formThankYou.style.display = 'block'
    }

    return true
  }

  showError(form, 'Sorry, it was not possible to share this article.')
  return false
}

function showError(form, message) {
  if (!form) {
    return
  }

  const button = form.querySelector('button[type="submit"]')
  const oldError = form.querySelector('._form_error')
  const error = document.createElement('div')
  const wrapper = document.createElement('div')

  if (oldError) {
    oldError.parentNode.removeChild(oldError)
  }

  error.innerHTML = message
  error.className = '_error-inner _form_error _no_arrow'

  wrapper.className = '_form-inner'
  wrapper.appendChild(error)

  if (button) {
    button.parentNode.insertBefore(wrapper, button)
    button.disabled = false
  }
}

function formValidate(form) {
  const errors = []
  const allFormInputs = form.querySelectorAll('input, select, textarea')

  allFormInputs.forEach((input) => {
    if (!needsValidate(input) && input.type !== 'text') {
      return
    }

    input.addEventListener('blur', function () {
      this.value = this.value.trim()
      validateField(this, true)
    })

    input.addEventListener('input', function () {
      validateField(this, true)
    })
  })

  removeTooltips()

  allFormInputs.forEach((elem) => {
    if (!needsValidate(elem)) {
      return
    }

    elem.value = elem.value.trim()
    if (!validateField(elem)) {
      errors.push(true)
    }
  })

  if (errors.length > 0) {
    return false
  }

  return true
}

function prepareModal(button, shareArticleModal) {
  const listShareArticleTitle = Array.from(
    shareArticleModal.querySelectorAll(
      '.ModalShareArticleClientEducation__title'
    )
  )
  const listError = Array.from(
    shareArticleModal.querySelectorAll(
      '._field-wrapper ._error, ._error._above, ._error-inner._form_error, ._form-inner'
    )
  )
  const form = shareArticleModal.querySelector('form')
  const submitBtn = shareArticleModal.querySelector('button[type="submit"]')
  const formContent = shareArticleModal.querySelector('._form-content')
  const formThankYou = shareArticleModal.querySelector('._form-thank-you')
  const articleId = button?.dataset?.articleId || ''
  const title = button?.dataset?.title || ''

  listError.forEach((elem) => elem.remove())
  listShareArticleTitle.forEach(
    (shareArticleTitle) => (shareArticleTitle.textContent = title)
  )

  if (form) {
    form.reset()

    if (form?.articleId) {
      form.articleId.value = articleId
    }
  }

  if (formContent) {
    formContent.style.display = 'block'
  }

  if (formThankYou) {
    formThankYou.style.display = 'none'
  }

  if (submitBtn) {
    submitBtn.disabled = false
  }

  openModal(shareArticleModal)
}

function openModal(elm) {
  document.body.classList.add('lockscroll-active')
  return elm.classList.remove('hidden')
}

function closeModal(elm) {
  document.body.classList.remove('lockscroll-active')
  return elm.classList.add('hidden')
}

async function sendEmail(data) {
  const params = []

  if (data?.articleId) {
    params.push(`article_id=${data.articleId}`)
  }

  if (data?.name) {
    params.push(`name=${data.name}`)
  }

  if (data?.clinicName) {
    params.push(`clinic_name=${data.clinicName}`)
  }

  if (data?.recipientEmail) {
    params.push(`recipient_email=${data.recipientEmail}`)
  }

  if (data?.token) {
    params.push(`token=${data.token}`)
  }

  const result = await fetchSendEmail(params)
  return result
}

async function fetchSendEmail(params) {
  const response = await fetch(
    `/wp-json/client-education-library/v1/share-this-article?${params.join(
      '&'
    )}`,
    {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  try {
    const json = await response.json()

    if (!json.success) {
      return false
    }

    return true
  } catch (e) {}

  return false
}
